import {TypeOnErrorFn} from "@helpers/query/types";
import {DataTrackDeviceActivity, IDataDeviceActivity} from "@containers/device/containers/deviceActivity/types";
import {transformTrackDeviceActivity} from "./transformTrackDeviceActivity";
import {TRACK_PATH} from "@constants/config";
import {apiRequest} from "@helpers/query/apiRequest";


export const getTrackDeviceActivity = (onError: TypeOnErrorFn): Promise<DataTrackDeviceActivity> => {
    const url = `${TRACK_PATH}/dashboard/details-statistic`
    return apiRequest<DataTrackDeviceActivity>({
        url,
        options: {
            method: 'GET'
        },
        onError
    })
}
export const getDeviceActivity = async (onError: TypeOnErrorFn): Promise<IDataDeviceActivity> => {

    const trackDeviceActivity = await getTrackDeviceActivity(onError)

    return transformTrackDeviceActivity(trackDeviceActivity)
};

